import React, {Component} from 'react';
import {connect} from 'react-redux';
import agent from '../../agent';
import PostPreview from "../Post/PostPreview";
import {getLabel} from "../../language";
import {loadCommentsList} from "../../actions/commentsList";


const mapStateToProps = state => ({
    ...state.postList,
    currentUser: state.common.currentUser,
    mention: state.mention,
    commentsList: state.commentsList.list,
    anonymous: state.user.anonymousMode,
    page: state.page
});

const mapDispatchToProps = dispatch => ({
    loadCommentsList: dispatch(loadCommentsList),
});

class LocationDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            dropDown: false,
            commentShow: false,
        }
    }

    componentDidMount = () => {
        const urlSlug = this.props.locationTag.countryName
        agent.Pollies.getPostByTopicOrLocation(urlSlug, this.props.locationTag.typePage).then(resp => {
            if (resp.length > 0 && resp[0].id) {
                agent.Pollies.getPostByTagId(resp[0].id).then(res => {
                    this.setState({
                        posts: res
                    });
                    if (res?.length > 0) {
                        const postsIds = this.getPostsIds(res);
                        if (postsIds?.length) {
                            this.props.loadCommentsList(postsIds.toString());
                        }
                    }
                })
            }
        })
        if (this.props?.commentId) {
            const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
            if (elements) {
                elements.scrollIntoView({behavior: "smooth"})
            }
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props?.commentId) {
            const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
            if (elements) {
                elements.scrollIntoView({behavior: "smooth"})
            }
        }
    }

    getPostsIds = (res, posts) => {
        let postsList = posts ? posts : res;
        if (postsList?.length > 0) {
            return postsList.map(item => {
                return item.id
            })
        }
    };

    dropDownClick = () => {
        this.setState({
            dropDown: !this.state.dropDown
        })
    };

    render() {
        const {posts} = this.state;
        return (
            <>
                {this.props?.locationTag && this.props?.locationTag?.countryName &&
                <div className="leftcontent">
                    <div className={`politiqbox${this.props.anonymous ? "-dark" : ""}`}>
                        <h3 className={`${this.props.anonymous ? "cw" : ""}`}>{this.props.locationTag.countryName}</h3>
                    </div>
                </div>
                }
                {
                    posts && posts.length > 0 ? posts.map((item, index) => {
                            return (
                                <PostPreview
                                    commentsList={this.props.commentsList}
                                    dropDownClick={this.dropDownClick}
                                    commentShow={this.state.commentShow}
                                    dropDown={this.state.dropDown}
                                    mention={this.props.mention}
                                    post={item}
                                    index={index}
                                    key={item.id}
                                    tags={item.tags}
                                    {...this.props}
                                />
                            );
                        })
                        : <div className={`${this.props.anonymous ? "cw" : ""} note-nothing-post`}>{getLabel(294)}</div>
                }
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationDetails);
